
































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import _auth from "@/utils/auth";

@Component
export default class NavBar extends Vue {
  // Use a class property for dependencies so unit tests can override them
  auth = _auth;

  @Prop() readonly title!: string;

  backRoute = "";

  get isLoggedIn() {
    return this.auth.isLoggedIn();
  }

  get showBackArrow() {
    return !!this.backRoute;
  }

  get hasMultipleLocations() {
    const countOfClients = this.auth.user?.clientIds.length || 0;
    return countOfClients > 1;
  }

  beforeUpdate() {
    if (this.$route.path.startsWith("/patients/")) {
      this.backRoute = "/my-patients";
    } else if (this.$route.path.startsWith("/credits")) {
      this.backRoute = "/about";
    } else if (this.$route.path.startsWith("/eula")) {
      this.backRoute = "/about";
    } else if (this.$route.path === "/change-password") {
      // Use the redirect path, otherwise go back to user-profile
      this.backRoute = (this.$route.query.redirectTo as string | null) || "/user-profile";
    } else {
      this.backRoute = "";
    }
  }

  moveBack() {
    this.$router.push(this.backRoute);
  }

  async logout() {
    // Logout then redirect the user to the sign in page
    await this.auth.logout();
    // Let the Sign In page know that the user signed out so that it doesn't try to prompt for biometrics
    this.$router.push({ path: "/sign-in", query: { loggedOut: "true" } });
  }
}
